import { render } from "./allInvestmentList.vue?vue&type=template&id=86def38a"
import script from "./allInvestmentList.vue?vue&type=script&lang=js"
export * from "./allInvestmentList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__